import { useState } from 'react';
import { securityFailure, type SecurityAction } from './securityFailure';

type Failure = { action: SecurityAction; text: string; unknown: boolean };

/**
 * Führt eine Änderung der Kontosicherheit aus und hält ihren Fehler als Satz. `onOpen` läuft, wenn
 * offen ist, ob die Änderung wirkte: dann zählt der neu geladene Stand, nicht der offene Schritt.
 */
export function useSecurityRun(onOpen: () => void, refresh: () => void) {
  const [failure, setFailure] = useState<Failure | null>(null);
  const run = async (action: SecurityAction, work: () => Promise<void>) => {
    setFailure(null);
    try {
      await work();
    } catch (error) {
      const result = await securityFailure(error, action);
      setFailure({ action, ...result });
      if (result.unknown) onOpen();
      refresh();
    }
  };
  /** Der bekannte Fehler einer Aktion an ihrem Ort; offene Ausgänge stehen über der Seite. */
  const shown = (action: SecurityAction) =>
    failure && !failure.unknown && failure.action === action ? failure.text : null;
  return { failure, setFailure, run, shown };
}
